import styles from './RadioButton.module.scss';
import { FormControlLabel, Radio } from '@mui/material';
import { FC } from 'react';

type TRadioButtonProps = {
    isActive: boolean;
    label: string;
    onChange: () => void;
    testid?: string;
};

const RadioButton: FC<TRadioButtonProps> = (props) => {
    const { isActive, label, onChange, testid } = props;
    return (
        <section className={styles.container} data-testid={testid ? testid : undefined}>
            <FormControlLabel label={label} control={<Radio onChange={onChange} checked={isActive} />} />
        </section>
    );
};

export default RadioButton;
